import { urls } from "../../constants";
import { axiosService } from "../axios.service";

const productsService = {
  getAllProducts: (params = {}) =>
    axiosService.get(urls.settings.products, { params }).then((value) => value.data),
  createProduct: (data) => axiosService.post(urls.settings.products, data).then((value) => value.data),
  updateProductById: (id, data) =>
    axiosService.patch(`${urls.settings.products}/${id}`, data).then((value) => value.data),
  deleteProductById: (id) =>
    axiosService.destroy(`${urls.settings.products}/${id}`),
  bulkUpdateWeight: (items) =>
    axiosService.patch(`${urls.settings.products}/bulk-weight`, { items }).then((value) => value.data),
};

export { productsService };
